export const buildingsRoutes = {
  getBuilding: propertyId => "/properties/".concat(propertyId, "/buildings"),
  getBuildingsBatch: '/buildings/list'
};